import { type MetaFunction } from '@remix-run/node'
import { Link } from '@remix-run/react'

export const meta: MetaFunction = () => [{ title: 'Ecofo' }]

export default function Index() {
	return (
		<main className="font-poppins grid h-full place-items-center">
			<div className="flex flex-col items-center text-center px-4 py-16">
				<h1
					data-heading
					className="text-4xl font-medium text-foreground md:text-5xl xl:text-6xl"
				>
					Ecofo
				</h1>
				<p
					data-paragraph
					className="mt-4 text-xl text-muted-foreground"
				>
					An ecosystem of transformation. A combination of custom video software with a new community platform. The app itself is invite-only at this point.
				</p>
				<div className="mt-8 flex gap-6 text-sm text-muted-foreground">
					<Link to="/terms" className="underline hover:no-underline">
						Terms
					</Link>
					<Link to="/privacy" className="underline hover:no-underline">
						Privacy
					</Link>
				</div>
			</div>
		</main>
	)
}
